import { normaliseText } from './normalise-text';

type SearchField = string | undefined | readonly string[];

export function matchesQuery(query: string, ...fields: readonly SearchField[]): boolean {
  const q = normaliseText(query.trim());
  if (!q) return true;
  return fields.some(function fieldMatches(field) {
    if (field === undefined) return false;
    if (typeof field === 'string') return normaliseText(field).includes(q);
    return field.some((value) => normaliseText(value).includes(q));
  });
}
